module.exports = __webpack_public_path__ + "static/media/student31.7f9bf8e3.png";